import * as React from 'react';
import MomentUtils from '@date-io/moment';
import TextField from '../TextField';
import Checkbox from '../Checkbox';
import Select, { SelectItem } from '../Select';
import DatePicker from '../Pickers/DatePicker';
import DateTimePicker from '../Pickers/DateTimePicker';
import TypeAhead from '../TypeAhead';
export var EditableInput = function EditableInput(props) {
  var _ref = props || {},
      disabled = _ref.disabled,
      e2e = _ref.e2e,
      type = _ref.type,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      value = _ref.value;

  if (!type || type === 'string' || type === 'relationship') {
    // TODO: move relationship out into typeahead searching component
    var error = props.error,
        helperText = props.helperText,
        multiline = props.multiline,
        rows = props.rows,
        maxlength = props.maxlength;
    return /*#__PURE__*/React.createElement(TextField, {
      disabled: disabled,
      e2e: e2e,
      value: value === undefined ? null : value,
      dsOnChange: function dsOnChange(val) {
        onChange === null || onChange === void 0 ? void 0 : onChange(val.target.value);
      },
      dsOnBlur: onBlur,
      dsOnFocus: onFocus,
      error: error,
      fullWidth: true,
      helperText: helperText,
      multiline: multiline,
      rows: rows,
      maxlength: maxlength
    });
  }

  if (type === 'boolean') {
    return /*#__PURE__*/React.createElement(Checkbox, {
      disabled: disabled,
      e2e: e2e,
      label: "",
      checked: typeof value === 'boolean' ? value : value === 'true' ? true : false,
      dsOnChange: function dsOnChange(val) {
        onChange === null || onChange === void 0 ? void 0 : onChange(val.target.checked);
      }
    });
  }

  if (type === 'number') {
    var _error = props.error,
        _helperText = props.helperText;
    return /*#__PURE__*/React.createElement(TextField, {
      disabled: disabled,
      e2e: e2e,
      type: "number",
      value: value,
      dsOnChange: function dsOnChange(val) {
        onChange === null || onChange === void 0 ? void 0 : onChange(val.target.value);
      },
      dsOnBlur: onBlur,
      dsOnFocus: onFocus,
      error: _error,
      fullWidth: true,
      helperText: _helperText
    });
  } // /**
  //  * There is an open issue to create a InputNumber component natively in MUI,
  //  * https://github.com/mui-org/material-ui/issues/19154
  //  */


  if (type === 'integer') {
    var _error2 = props.error,
        _helperText2 = props.helperText;
    return /*#__PURE__*/React.createElement(TextField, {
      disabled: disabled,
      e2e: e2e,
      type: "number",
      value: value,
      dsOnChange: function dsOnChange(e) {
        // when they clear return an empty string
        if (e.target.value === '') {
          onChange === null || onChange === void 0 ? void 0 : onChange('');
          return;
        }

        var parsedInt = parseInt(e.target.value); // only allow it to be changed if its a valid integer

        if (Number.isInteger(parsedInt)) {
          onChange === null || onChange === void 0 ? void 0 : onChange(String(parsedInt));
        }
      },
      dsOnBlur: onBlur,
      dsOnFocus: onFocus,
      error: _error2,
      fullWidth: true,
      helperText: _helperText2
    });
  }

  if (type === 'date') {
    var _error3 = props.error,
        _helperText3 = props.helperText,
        dateFormat = props.dateFormat,
        minDate = props.minDate,
        maxDate = props.maxDate;
    var format = dateFormat || 'MM/DD/YYYY';
    return /*#__PURE__*/React.createElement(DatePicker, {
      disabled: disabled,
      e2e: e2e,
      utils: MomentUtils,
      value: value,
      format: format,
      dsOnChange: function dsOnChange(val) {
        if (val === null || val === void 0 ? void 0 : val.isValid()) {
          onChange === null || onChange === void 0 ? void 0 : onChange(val.format(format));
        }
      },
      error: _error3,
      fullWidth: true,
      helperText: _helperText3,
      minDate: minDate,
      maxDate: maxDate
    });
  }

  if (type === 'date-time') {
    var _error4 = props.error,
        _helperText4 = props.helperText,
        _dateFormat = props.dateFormat,
        _minDate = props.minDate,
        _maxDate = props.maxDate;

    var _format = _dateFormat || 'MM/DD/YYYY';

    return /*#__PURE__*/React.createElement(DateTimePicker, {
      e2e: e2e,
      value: String(value),
      format: _format,
      dsOnChange: function dsOnChange(val) {
        if (val === null || val === void 0 ? void 0 : val.isValid()) {
          onChange === null || onChange === void 0 ? void 0 : onChange(val.toISOString());
        }
      },
      error: _error4,
      fullWidth: true,
      helperText: _helperText4,
      minDate: _minDate,
      maxDate: _maxDate
    });
  }

  if (type === 'picklist') {
    var _error5 = props.error,
        _helperText5 = props.helperText,
        picklistOptions = props.picklistOptions,
        picklistEmptyOption = props.picklistEmptyOption,
        picklistUniqueKey = props.picklistUniqueKey;
    return /*#__PURE__*/React.createElement(Select, {
      disabled: disabled,
      e2e: e2e,
      dsOnChange: function dsOnChange(val) {
        // @ts-ignore
        onChange(val.target.value);
      },
      error: _error5,
      fullWidth: true,
      helperText: _helperText5,
      label: "",
      value: value
    }, picklistEmptyOption ? /*#__PURE__*/React.createElement(SelectItem, {
      key: "".concat(picklistUniqueKey, "-").concat(picklistEmptyOption),
      value: ""
    }, picklistEmptyOption) : null, picklistOptions === null || picklistOptions === void 0 ? void 0 : picklistOptions.map(function (option) {
      return /*#__PURE__*/React.createElement(SelectItem, {
        key: "".concat(picklistUniqueKey, "-").concat(option),
        value: option
      }, option);
    }));
  }

  if (type === 'typeahead') {
    var _error6 = props.error,
        _helperText6 = props.helperText,
        typeaheadLoading = props.typeaheadLoading,
        typeaheadOptions = props.typeaheadOptions,
        _props$typeaheadGetOp = props.typeaheadGetOptionLabel,
        typeaheadGetOptionLabel = _props$typeaheadGetOp === void 0 ? function (val) {
      return val;
    } : _props$typeaheadGetOp,
        typeaheadRenderOption = props.typeaheadRenderOption;
    return /*#__PURE__*/React.createElement(TypeAhead, {
      disabled: disabled,
      e2e: e2e,
      dsOnChange: function dsOnChange(_, val) {
        onChange === null || onChange === void 0 ? void 0 : onChange(val);
      },
      error: _error6,
      fullWidth: true,
      getOptionLabel: typeaheadGetOptionLabel,
      dsRenderOption: typeaheadRenderOption,
      helperText: _helperText6,
      loading: typeaheadLoading,
      options: typeaheadOptions,
      value: value
    });
  }

  return null;
};

try {
  EditableInput.__docgenInfo = {
    description: '',
    displayName: 'EditableInput',
    methods: [],
    props: {
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        required: true,
        type: {
          name: 'any'
        }
      },
      disabled: {
        defaultValue: null,
        description: '',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      error: {
        defaultValue: null,
        description: '',
        name: 'error',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      helperText: {
        defaultValue: null,
        description: '',
        name: 'helperText',
        required: false,
        type: {
          name: 'string'
        }
      },
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        required: false,
        type: {
          name: '(value: any) => void'
        }
      },
      onBlur: {
        defaultValue: null,
        description: '',
        name: 'onBlur',
        required: false,
        type: {
          name: '() => void'
        }
      },
      onFocus: {
        defaultValue: null,
        description: '',
        name: 'onFocus',
        required: false,
        type: {
          name: '() => void'
        }
      },
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        required: true,
        type: {
          name: 'enum',
          raw: '"string" | "number" | "boolean" | "date" | "typeahead" | "relationship" | "integer" | "date-time" | "picklist"',
          value: [{
            value: '"string"'
          }, {
            value: '"number"'
          }, {
            value: '"boolean"'
          }, {
            value: '"date"'
          }, {
            value: '"typeahead"'
          }, {
            value: '"relationship"'
          }, {
            value: '"integer"'
          }, {
            value: '"date-time"'
          }, {
            value: '"picklist"'
          }]
        }
      },
      multiline: {
        defaultValue: null,
        description: '',
        name: 'multiline',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      rows: {
        defaultValue: null,
        description: '',
        name: 'rows',
        required: false,
        type: {
          name: 'number'
        }
      },
      maxlength: {
        defaultValue: null,
        description: '',
        name: 'maxlength',
        required: false,
        type: {
          name: 'number'
        }
      },
      dateFormat: {
        defaultValue: null,
        description: '',
        name: 'dateFormat',
        required: false,
        type: {
          name: 'string'
        }
      },
      minDate: {
        defaultValue: null,
        description: '',
        name: 'minDate',
        required: false,
        type: {
          name: 'string'
        }
      },
      maxDate: {
        defaultValue: null,
        description: '',
        name: 'maxDate',
        required: false,
        type: {
          name: 'string'
        }
      },
      picklistOptions: {
        defaultValue: null,
        description: '',
        name: 'picklistOptions',
        required: false,
        type: {
          name: 'string[]'
        }
      },
      picklistEmptyOption: {
        defaultValue: null,
        description: '',
        name: 'picklistEmptyOption',
        required: false,
        type: {
          name: 'string'
        }
      },
      picklistUniqueKey: {
        defaultValue: null,
        description: '',
        name: 'picklistUniqueKey',
        required: true,
        type: {
          name: 'string'
        }
      },
      typeaheadOptions: {
        defaultValue: null,
        description: '',
        name: 'typeaheadOptions',
        required: false,
        type: {
          name: 'any'
        }
      },
      typeaheadLoading: {
        defaultValue: null,
        description: '',
        name: 'typeaheadLoading',
        required: false,
        type: {
          name: 'any'
        }
      },
      typeaheadGetOptionLabel: {
        defaultValue: null,
        description: '',
        name: 'typeaheadGetOptionLabel',
        required: false,
        type: {
          name: 'any'
        }
      },
      typeaheadRenderOption: {
        defaultValue: null,
        description: '',
        name: 'typeaheadRenderOption',
        required: false,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=EditableInput.js.map